import { getTranslationKey } from 'helpers/texting';
import type { IPendingSelectionEdit } from 'modules/ScrAppBookNew/store/ui';

const TEXT_KEY = {
  wrongAccount: 'otpLogin.editSelectionWrongAccount',
  signIn: 'otpLogin.editSelectionSignIn'
} as const;

// Description of the login email screen when it was opened by Edit on a saved selection.
export const getSelectionEditSignInText = (pending: IPendingSelectionEdit | null) =>
  pending ? String(getTranslationKey(TEXT_KEY[pending.reason])) : undefined;
